import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useConnect } from '@lore/query-connect';
import Overlay from '../../../forms/_common/Overlay';
import FormErrors from '../../../forms/_common/FormErrors';
import RequestError from '../../../forms/_common/RequestError';
import ErrorMessage from '../../../forms/_common/ErrorMessage';
import SolidButton from '../../../components/Button/SolidButton';
import FormTemplate2 from '../../_post-opportunity/FlowTemplate';
import { PayloadStates } from '@lore/utils';
import OfferUpload from './OfferUpload';
import Upload from '../../project-create/documents/Upload';
import FormSection from '../../_post-opportunity/forms/FormSection';
import { useQueryMutation } from '../../../../hooks/@lore/query-connect';
import Card from '../../../components/Card';
import UploadImageDestroyable from '../../evaluation-project-educator/Uploads/UploadImageDestroyable';
import UploadDocumentDestroyable from '../../evaluation-project-educator/Uploads/UploadDocumentDestroyable';
import getUploadInfo from '../../evaluation-project-educator/Uploads/getUploadInfo';

Form.propTypes = {
  user: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func,
  onSkip: PropTypes.func
};

export default function Form(props) {
  const {
    user,
    offer,
    navigation,
    onNext,
    onPrevious,
    onSkip,
    onExit,
    FormTemplate = FormTemplate2,
    buttonText = 'Next'
  } = props;

  const offerUploads = useConnect('upload.find', {
    where: {
      eager: {
        $where: {
          offerId: offer.id
        }
      }
    }
  });

  const [data, setData] = useState(_.pick(offer.data, [
    // 'field'
  ]));
  const [showErrors, setShowErrors] = useState(false);
  const [exit, setExit] = useState(false);

  const mutation = useQueryMutation('offer.update', offer);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      exit ? onExit(data) : onNext(data);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate(data);
  }

  function onSubmitAndExit() {
    onSubmit();
    setExit(true);
  }

  function onChange(name, value) {
    setData(_.merge({}, data, {
      [name]: value
    }));
  }

  function onUpload(upload) {
    // lore.actions.offerUpload.create({
    //   offerId: offer.id,
    //   uploadId: upload.id
    // }).payload
  }

  const offerImages = {
    data: offerUploads.data.filter(function(offerUpload) {
      return getUploadInfo(offerUpload.data.name).isImage;
    })
  };

  const offerDocuments = {
    data: offerUploads.data.filter(function(offerUpload) {
      return !getUploadInfo(offerUpload.data.name).isImage;
    })
  };

  return (
    <Overlay isVisible={saving}>
      <FormErrors data={data} validators={{
        // field: [validators.isRequired]
      }}>
        {({ errors, hasError }) => {
          return (
            <FormTemplate
              onExit={() => hasError ? setShowErrors(true) : onSubmitAndExit()}
              onPrevious={onPrevious}
              navigation={navigation}
              alert={error ? (
                <RequestError request={request} />
              ) : showErrors ? (
                <ErrorMessage>
                  Please fill in all required fields.
                </ErrorMessage>
              ) : null}
              body={(
                <FormSection
                  // title="Offer Documents"
                >
                  <div className="space-y-8">
                    <Card className="py-5 px-6 bg-white shadow-lg rounded-xl">
                      <div className="border border-dashed border-cs-orange-500 bg-cs-orange-500 bg-opacity-20 rounded-lg text-center py-20">
                        <OfferUpload
                          offer={offer}
                          onUpload={onUpload}
                        />
                      </div>
                    </Card>
                    {offerImages.data.length > 0 && (
                      <FormSection title="Offer Images">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4">
                          {offerImages.data.map(function(offerUpload) {
                            return (
                              <UploadImageDestroyable
                                key={offerUpload.id || offerUpload.cid}
                                upload={offerUpload}
                              />
                            );
                          })}
                        </div>
                      </FormSection>
                    )}
                    {offerDocuments.data.length > 0 && (
                      <FormSection title="Offer Documents">
                        <div className="grid grid-cols-1 sm:grid-cols-2x gap-6">
                          {offerDocuments.data.map(function(offerUpload) {
                            return (
                              <UploadDocumentDestroyable
                                key={offerUpload.id || offerUpload.cid}
                                upload={offerUpload}
                              />
                            );
                          })}
                        </div>
                      </FormSection>
                    )}
                  </div>
                </FormSection>
              )}
              footer={(
                <>
                  <SolidButton onClick={() => hasError ? setShowErrors(true) : onSubmit()}>
                    {buttonText}
                  </SolidButton>
                </>
              )}
            />
          );
        }}
      </FormErrors>
    </Overlay>
  );
};
